import {
  DashboardPromptTemplatesListDocument,
  type DashboardPromptTemplatesListQuery,
  type DashboardPromptTemplatesListQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_PROMPT_BLOCKS_LIST_LOADER = async () => {
  const { data } = await client.query<
    DashboardPromptTemplatesListQuery,
    DashboardPromptTemplatesListQueryVariables
  >({
    query: DashboardPromptTemplatesListDocument,
    fetchPolicy: "network-only",
  });

  return data;
};
